import { SkinAttribute } from "./v1";
import { SkinAttributeV2 } from "./v2";

export type SkinAttributeV1Type = keyof typeof SkinAttribute;
export type SkinAttributeV2Type = keyof typeof SkinAttributeV2;

export type SkinAttributeType = SkinAttributeV1Type | SkinAttributeV2Type;
